import { CABIN_CLASS, BOOKING_CLASS } from './constant';
import { bookingClassOptionsByRule, cabinClassOptions } from './variousOptionsProvider';

const getOptionsByField = (field, cabinClassValue) => {
  if (field === BOOKING_CLASS) {
    return bookingClassOptionsByRule[cabinClassValue] || [];
  }

  if (field === CABIN_CLASS) {
    return cabinClassOptions();
  }

  return [];
};

const getValuesByField = (field, bookingClassValues, cabinClassValue) => {
  const normalizedBookingClassValues = Array.isArray(bookingClassValues) ? bookingClassValues : [];

  if (field === BOOKING_CLASS) {
    return normalizedBookingClassValues.map(value => ({
      label: value,
      value,
    }));
  }

  if (field === CABIN_CLASS) {
    return cabinClassOptions().find(option => option.value === cabinClassValue) || null;
  }

  return null;
};

const getSelectBoxData = (field, bookingClassValues, cabinClassValue) => {
  const PLACEHOLDER_TEXT = {
    bookingClass: I18n.t('components.ibe.search_form.flight.label.booking_class'),
    cabinClass: I18n.t('components.ibe.search_form.flight.label.cabin_class'),
  }[field];

  return {
    placeholderText: PLACEHOLDER_TEXT,
    options: getOptionsByField(field, cabinClassValue),
    values: getValuesByField(field, bookingClassValues, cabinClassValue),
  };
};

export default getSelectBoxData;
